var map = {
	"./Betjet.png": 6169,
	"./EB-Crash.png": 5976,
	"./EB-Double-Stars-new.png": 9645,
	"./EB-Double-stars.png": 6895,
	"./EB-Mines.png": 8356,
	"./ES-motograu.png": 7289,
	"./EdS-double.png": 1631,
	"./FAN-scratch.png": 8519,
	"./FAN-slot.png": 3038,
	"./Gambling-Commission-logo-white.png": 9706,
	"./JG-logo.png": 3086,
	"./JG-logo.svg": 8840,
	"./Jetman.png": 8317,
	"./Slingo-Cleo.png": 690,
	"./Slingo-GE.png": 158,
	"./Slingo-SW.png": 3739,
	"./SwishSlots.png": 4365,
	"./Zoomex.png": 6510,
	"./armed.png": 8795,
	"./beejet.png": 7708,
	"./black_logo.svg": 9933,
	"./blackjack.png": 4414,
	"./chandan.png": 5865,
	"./cleoass.png": 9010,
	"./cleoneedle.png": 7994,
	"./ded.png": 5884,
	"./diamond.png": 9202,
	"./flyovni.png": 6165,
	"./fruity.png": 3882,
	"./ip-ccooh.png": 8774,
	"./ip-coronation.png": 2461,
	"./ip-dond.png": 844,
	"./ip-hk.png": 3854,
	"./ip-li.png": 2961,
	"./ip-s.png": 9573,
	"./ip-tc.png": 8984,
	"./ip-tp.png": 5022,
	"./ip-tv.png": 7027,
	"./jet-man.jpg": 5953,
	"./jetman2.png": 768,
	"./jewell.png": 4029,
	"./last.png": 523,
	"./logo.png": 6949,
	"./mgalogo.png": 9920,
	"./mines.jpg": 874,
	"./mines.png": 6049,
	"./motograu.png": 641,
	"./roulette.png": 3251,
	"./stelar.png": 5996,
	"./superbomb.png": 7766,
	"./thumb-1.png": 1310,
	"./thumb-10.png": 7185,
	"./thumb-11.png": 1655,
	"./thumb-12.png": 5744,
	"./thumb-13.png": 1033,
	"./thumb-14.png": 3502,
	"./thumb-15.png": 9779,
	"./thumb-16.png": 9509,
	"./thumb-17.png": 2664,
	"./thumb-18.png": 1632,
	"./thumb-19.png": 8420,
	"./thumb-2.png": 7732,
	"./thumb-20.png": 1541,
	"./thumb-21.png": 8655,
	"./thumb-22.png": 497,
	"./thumb-3.png": 3104,
	"./thumb-4.png": 7972,
	"./thumb-5.png": 1888,
	"./thumb-6.png": 8334,
	"./thumb-7.png": 2124,
	"./thumb-8.png": 5826,
	"./thumb-9.png": 5294,
	"./thumb-aviaozinho.png": 1462,
	"./thumb-banana-heist.png": 737,
	"./thumb-beebat.png": 2028,
	"./thumb-betmgm-3-strikes.png": 1080,
	"./thumb-betmgm-big-wheel.png": 730,
	"./thumb-betmgm-hole-in-one.png": 8467,
	"./thumb-betmgm-plinko.png": 2132,
	"./thumb-betmgm-rat-race.png": 986,
	"./thumb-betmgm-spelling-bee-mines.png": 5505,
	"./thumb-crash-Grau7K.png": 9325,
	"./thumb-crash-Kickoff.png": 9303,
	"./thumb-crash-OSurfista.png": 3519,
	"./thumb-crash-beejet.png": 9379,
	"./thumb-crash-jetman.png": 6222,
	"./thumb-crash-motograu.png": 985,
	"./thumb-crash-of-the-gods.png": 5908,
	"./thumb-crash-stelar.png": 2861,
	"./thumb-crash-superbomb.png": 9708,
	"./thumb-deal.png": 8777,
	"./thumb-docebonanza.png": 4580,
	"./thumb-dond-world.png": 8046,
	"./thumb-everi-bottle-crash-course.png": 3958,
	"./thumb-everi-cliffhangers.png": 8514,
	"./thumb-everi-cosmic-pinball-blast.png": 6827,
	"./thumb-everi-double-salmon.png": 9635,
	"./thumb-everi-eagles-reign.png": 7373,
	"./thumb-everi-evel-knievel.png": 4826,
	"./thumb-everi-puffer-popper.png": 1247,
	"./thumb-everi-skate-city-cash.png": 4659,
	"./thumb-everi-star-struck-riches.png": 1662,
	"./thumb-everi-survivor-spin.png": 15,
	"./thumb-everi-the-voice-pick.png": 342,
	"./thumb-everi-vault-of-destiny.png": 3537,
	"./thumb-everi-vault-of-fortune.png": 101,
	"./thumb-everi-wwtbam-mines.png": 5287,
	"./thumb-everi-wwtbam-spins.png": 6206,
	"./thumb-everi-yeti-cash-smash.png": 9140,
	"./thumb-family-feud-crash.png": 6480,
	"./thumb-family-feud-pick.png": 8549,
	"./thumb-fanduel-over-under.png": 198,
	"./thumb-fanduel-picknspin.png": 7718,
	"./thumb-flyovni.png": 252,
	"./thumb-jogo-bicho.png": 1593,
	"./thumb-joker.png": 7055,
	"./thumb-macacodafortuna.png": 9305,
	"./thumb-pandadafortuna.png": 453,
	"./thumb-paperPlane.png": 5120,
	"./thumb-path-finder.png": 703,
	"./thumb-punch-a-bunch.jpg": 9515,
	"./thumb-slingo-chinashores.png": 4406,
	"./thumb-slingo-cleo.png": 7253,
	"./thumb-slingo-ge.png": 2220,
	"./thumb-slingo-sw.png": 5293,
	"./thumb-survivor.png": 6746,
	"./thumb-vdr.png": 5127,
	"./video/Mines-EDS.mp4": 1767,
	"./video/SnapInsta.io-MENOR ERICSON - MOTOGRAU.mp4": 3046,
	"./video/SnapInsta.io-MOTOGRAU ESTRELABET.mp4": 6513,
	"./video/kickoff.mp4": 3495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;